export default __webpack_public_path__ + "static/media/Image3.f753cd09.JPG";